import Icon from '../components/Icon.vue'

Icon.register({
  infinity: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M471.1 96C405 96 353.3 137.3 320 174.6 286.7 137.3 235 96 168.9 96 75.8 96 0 167.8 0 256S75.8 416 168.9 416C235 416 286.7 374.7 320 337.4 353.3 374.7 405 416 471.1 416 564.2 416 640 344.2 640 256S564.2 96 471.1 96zM168.9 320C128.7 320 96 291.3 96 256S128.7 192 168.9 192C207.1 192 242.3 228.1 262.9 256 242.5 283.6 207 320 168.9 320zM471.1 320C432.9 320 397.7 283.9 377.1 256 397.5 228.4 433 192 471.1 192 511.3 192 544 220.7 544 256S511.3 320 471.1 320z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/infinity.js
// module id = BXM2
// module chunks = 144